import { HTMLAttributes } from 'react';

const SearchSectionTitle = ({ children }: HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className="mb-4 mt-0 flex grow font-semibold capitalize leading-tight text-primary-500 lg:mb-6 lg:leading-none">
    {children}
  </h2>
);

export default SearchSectionTitle;
